let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("MKJsQ")).then(() => parcelRequire('7RVQf'));